import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { API_URL } from "@/shared"
import { showNotification } from "@mantine/notifications"
import { Clinic } from "../domain/clinic.types"

export const useClinics = () => {
  return useQuery<Clinic[]>({
    queryKey: ["clinics"],
    queryFn: async () => {
      try {
        const response = await axios.get(`${API_URL}/clinics`)
        return response.data.data
      } catch (err) {
        console.error("Error getting clinics", err)
        showNotification({ title: "Error al obtener clínicas", message: "No se pudieron cargar las clínicas. Inténtelo nuevamente.", color: "red" })
        throw err
      }
    }
  })
}

export const useCreateClinic = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (clinicData: Partial<Clinic>) => {
      try {
        const response = await axios.post(`${API_URL}/clinics`, clinicData)
        showNotification({ title: "Clínica agregada", message: "La clínica ha sido agregada exitosamente.", color: "green" })
        return response.data.data
      } catch (err) {
        console.error("Error creating clinic", err)
        showNotification({ title: "Error al agregar clínica", message: "No se pudo agregar la clínica. Inténtelo nuevamente.", color: "red" })
        throw err
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["clinics"] })
    }
  })
}

export const useUpdateClinic = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ id, clinicData }: { id: string; clinicData: Partial<Clinic> }) => {
      try {
        const response = await axios.put(`${API_URL}/clinics/${id}`, clinicData)
        showNotification({ title: "Clínica actualizada", message: "La clínica ha sido actualizada exitosamente.", color: "green" })
        return response.data.data
      } catch (err) {
        console.error("Error updating clinic", err)
        showNotification({ title: "Error al actualizar clínica", message: "No se pudo actualizar la clínica. Inténtelo nuevamente.", color: "red" })
        throw err
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["clinics"] })
    }
  })
}

export const useDeleteClinic = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (id: string) => {
      try {
        const response = await axios.delete(`${API_URL}/clinics/${id}`)
        showNotification({ title: "Clínica eliminada", message: "La clínica ha sido eliminada exitosamente.", color: "green" })
        return response.data
      } catch (err) {
        console.error("Error deleting clinic", err)
        showNotification({ title: "Error al eliminar clínica", message: "No se pudo eliminar la clínica. Inténtelo nuevamente.", color: "red" })
        throw err
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["clinics"] })
    }
  })
}
